import * as yup from "yup";

const validationSchema = yup.object().shape({
    // TODO: Required fields
});

export default validationSchema;
